import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConnectService } from './api-connect.service';
import { AssetAction, AssetHistory, AssetIssue, AssetOptions, AssetPage,
  AssetQuery, DepartmentAssetPage, DepartmentAssetQuery, EmployeeAsset } from '../models/employee-asset.model';
import { ASSET } from '../content-page/common/employee-assets/asset.constants';

@Injectable()
export class EmployeeAssetsService {
  constructor(private http: HttpClient, private api: ApiConnectService) {}

  list(query: AssetQuery): Observable<AssetPage> {
    return this.http.get<AssetPage>(this.base(), {params: this.params(query)});
  }

  department(id: string, query: DepartmentAssetQuery): Observable<DepartmentAssetPage> {
    const params = new HttpParams().set(ASSET.page, String(query.page))
      .set(ASSET.size, String(query.size || ASSET.pageSize)).set(ASSET.query, (query.q || ASSET.empty).trim());
    return this.http.get<DepartmentAssetPage>(this.base() + DEPARTMENTS_PATH + encodeURIComponent(id), {params: params});
  }


  get(id: string): Observable<EmployeeAsset> {
    return this.http.get<EmployeeAsset>(this.base() + ASSET.slash + encodeURIComponent(id));
  }

  options(employeeId: string, query?: string): Observable<AssetOptions> {
    let params = new HttpParams().set(ASSET.employeeId, employeeId);
    if (query) { params = params.set(ASSET.query, query); }
    return this.http.get<AssetOptions>(this.base() + ASSET.options, {params: params});
  }

  issue(request: AssetIssue): Observable<EmployeeAsset> {
    return this.http.post<EmployeeAsset>(this.base() + ASSET.issue, request);
  }

  act(id: string, request: AssetAction): Observable<EmployeeAsset> {
    return this.http.post<EmployeeAsset>(this.base() + ASSET.slash + id + ASSET.actions, request);
  }

  history(id: string, page: number): Observable<AssetHistory[]> {
    const params = new HttpParams().set(ASSET.page, String(page)).set(ASSET.size, String(ASSET.pageSize));
    return this.http.get<AssetHistory[]>(this.base() + ASSET.slash + id + ASSET.history, {params: params});
  }






  private base(): string { return this.api.baseApiUrl + ASSET.path; }

  private params(query: AssetQuery): HttpParams {
    let params = new HttpParams().set(ASSET.view, query.view).set(ASSET.page, String(query.page))
      .set(ASSET.size, String(ASSET.pageSize));
    if (query.employeeId) { params = params.set(ASSET.employeeId, query.employeeId); }
    if (query.ownerId) { params = params.set(ASSET.ownerId, query.ownerId); }
    return params;
  }
}
const DEPARTMENTS_PATH = '/departments/';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/employee-assets.service.ts